import type { Tag } from '../types'

/** Bluesky searchPosts wants simple terms — OR chains return zero results. */
export const DEFAULT_NSFW_TAGS: Tag[] = [
  { id: 't_edging', label: 'EDGING', query: '#edging', enabled: true, sort: 10 },
  { id: 't_fuel', label: 'GOON FUEL', query: '#gooning', enabled: true, sort: 20 },
  { id: 't_denial', label: 'TEASE DENIAL', query: '#teasedenial', enabled: true, sort: 30 },
  { id: 't_bigass', label: 'BIG ASS', query: '#bigass', enabled: true, sort: 40 },
  { id: 't_load', label: 'LOAD BUILD UP', query: '#cumshot', enabled: true, sort: 50 },
  { id: 't_cshot', label: 'CUMSHOT', query: '#cumshot', enabled: true, sort: 60 },
  { id: 't_nsfw', label: 'NSFW', query: '#nsfw', enabled: true, sort: 70 },
  { id: 't_tease', label: 'TEASE', query: '#tease', enabled: true, sort: 80 },
  { id: 't_edge', label: 'EDGE', query: '#edge', enabled: true, sort: 90 },
  { id: 't_distraction', label: 'DISTRACTION', query: '#nsfw', enabled: true, sort: 100 },
  { id: 't_pump', label: 'PUMP IT', query: '#gooner', enabled: true, sort: 110 },
  { id: 't_latenight', label: 'LATE NIGHT', query: '#latenight', enabled: true, sort: 120 },
]

const WHOLESOME = new Set(['cats', 'dogs', 'art', 'memes', 'nature', 'space', 'food', 'pixelart'])

/** OR-heavy queries Bluesky rejects — rewrite to primary hashtag. */
const QUERY_FIX: Record<string, string> = {
  t_edging: '#edging',
  t_fuel: '#gooning',
  t_denial: '#teasedenial',
  t_big: '#bigass',
  t_bigass: '#bigass',
  t_load: '#cumshot',
  t_cshot: '#cumshot',
  t_nsfw: '#nsfw',
  t_tease: '#tease',
  t_edge: '#edge',
  t_distraction: '#nsfw',
  t_pump: '#gooner',
  t_latenight: '#latenight',
  t_focus: '#nsfw',
}

export function tagsAreWholesome(tags: Array<{ label: string; id?: string }>): boolean {
  if (!tags.length) return true
  return tags.every((t) => WHOLESOME.has(t.label.trim().toLowerCase()) || t.id?.startsWith('t_cat') || t.id === 't_pixel')
}

export function normalizeTagQuery(tag: Tag): Tag {
  const fixed = QUERY_FIX[tag.id]
  if (fixed) return { ...tag, query: fixed, label: tag.label.toUpperCase() }
  // Strip OR chains from admin-entered queries — use first #tag or whole string.
  if (/\s+OR\s+/i.test(tag.query)) {
    const hash = tag.query.match(/#[\w]+/i)?.[0]
    if (hash) return { ...tag, query: hash, label: tag.label.toUpperCase() }
  }
  return { ...tag, label: tag.label.toUpperCase() }
}

export function ensureNsfwTags(tags: Tag[]): Tag[] {
  if (tagsAreWholesome(tags)) return DEFAULT_NSFW_TAGS
  return tags.map(normalizeTagQuery)
}